import { useMemo } from 'react';
import { themeStore, themeStoreActions } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export function useFonts() {
  const fonts = useSelectedFieldStore(themeStore, () => themeStore.get().fonts);

  return useMemo(
    () => ({
      fonts,
      setFonts: themeStoreActions.setFontsAction,
    }),
    [fonts]
  );
}
